module.exports = __webpack_public_path__ + "static/media/bg_2.b2b733b5.jpg";